import { render, staticRenderFns } from "./DemoTimePickerBasic.vue?vue&type=template&id=61f7f9ba&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../../landing-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../landing-app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTimePicker } from 'vuetify/lib/components/VTimePicker';
installComponents(component, {VTimePicker})
